// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__NCEfr","icon":"SortAdornment_icon__1rOmL","up":"SortAdornment_up__1y18d","down":"SortAdornment_down__2Yf13","active":"SortAdornment_active__1l0m-"};